module.exports = __webpack_public_path__ + "static/media/5.247ea21d.jpg";